/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./update-package.vue?vue&type=template&id=36903126&scoped=true&"
import script from "./update-package.vue?vue&type=script&lang=js&"
export * from "./update-package.vue?vue&type=script&lang=js&"
import style0 from "./update-package.vue?vue&type=style&index=0&id=36903126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36903126",
  null
  
)

export default component.exports